import axios from 'axios';
import API_BASE_URL from './api';

const token = localStorage.getItem('token');

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  },
});

export default axiosInstance;


// การนำไปใช้งานใช้แบบนี้
// ทำการ import จาก ไฟล์ axiosInstance แทนการ import จาก axios
// import axios from '../config/axiosInstance';

// export const getUsers = () => axios.get('/users');
